'use client'

import useAnalytics from '@/analytics/CookieBanner/useAnalytics'

function AnalyticsAutoOptIn() {
  useAnalytics('accepted')
  return null
}

export default AnalyticsAutoOptIn
